export const STRIPE_URL = '/stripe';
